<template>
  <div class="sm-action-notif">
    <transition-group name="fade">
      <div
        v-for="item in items"
        :key="item.id"
        class="sm-action-notif__item"
      >
        <a
          href="#"
          class="sm-action-notif__item-close"
          @click.prevent="removeItem(item.id)"
        ></a>
        <!-- <span>{{item.text}}</span> -->
        <text-truncate :text="item.text" />
        <a
          v-if="item.undo"
          href="#"
          class="sm-action-notif__item-undo sm-blue-link"
          @click.prevent="undoAction(item)"
        >Undo</a>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'action-notification',
  props: {
    add: {},
    remove: {}
  },
  data() {
    return {
      items: [],
      timeout: 5000
    };
  },
  methods: {
    addItem(val) {
      this.removeItem(val.id);

      if (this.items.length > 4)
        this.items.splice(-1, 1);

      this.items.unshift(val);

      setTimeout(() => {
        this.removeItem(val.id);
      }, this.timeout);
    },
    removeItem(id) {
      this.items = this.items.filter(item => item.id !== id);
    },
    undoAction(val) {
      this.$emit('undo', val);
    },
  },
  watch: {
    add(val) {
      this.addItem(val);
    },
    remove(val) {
      this.removeItem(val);
    }
  }
}
</script>

<style lang="scss">
  .fade-enter,
  .fade-leave-to {
    transform: translate(0, 100%);
  }

  .fade-enter-active {
    transition: transform .5s;
  }

  .fade-leave-active {
    transition: transform .2s;
  }
</style>